import React, {Fragment} from "react";
import {Seo, Breadcrumb, ScrollTopBtn} from "../components";
import {HeaderTwo, FooterTwo, TeamOrganizationChart} from "../containers";

const OrganizationChart = () => (
    <Fragment>
        <Seo title="Organization Chart" />
        <HeaderTwo />
        <Breadcrumb pageName="Organization Chart" bgImage="images/miw/bar-organization-chart.jpg" />
        <TeamOrganizationChart className="" />
        <FooterTwo />
        <ScrollTopBtn />
    </Fragment>
);

export default OrganizationChart;
